import { render, staticRenderFns } from "./MyFlicking.vue?vue&type=template&id=1369d97d&scoped=true"
import script from "./MyFlicking.vue?vue&type=script&lang=js"
export * from "./MyFlicking.vue?vue&type=script&lang=js"
import style0 from "./MyFlicking.vue?vue&type=style&index=0&id=1369d97d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1369d97d",
  null
  
)

export default component.exports